module.exports = __webpack_public_path__ + "img/teye-logo-blanc-transparent.c76b60c7.png";